module.exports = __webpack_public_path__ + "img/ipad_en.b127fae.jpg";